<div class="pca-dialog">
    <h2 mat-dialog-title class="pca-title">Pending Cancellation</h2>

    <mat-dialog-content class="pca-content">
        <p class="pca-subtitle">How would you like to proceed with this order?</p>

        <div class="pca-actions">
            <button class="pca-option" [class.pca-option--selected]="selectedAction === 'complete'"
                [class.pca-option--complete]="selectedAction === 'complete'" (click)="selectAction('complete')">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Complete Order</span>
            </button>

            <button class="pca-option" [class.pca-option--selected]="selectedAction === 'waitingRoom'"
                [class.pca-option--waiting]="selectedAction === 'waitingRoom'" (click)="selectAction('waitingRoom')">
                <mat-icon>schedule</mat-icon>
                <span>Move to Waiting Room</span>
            </button>

            <button class="pca-option pca-option--cancel-btn" [class.pca-option--selected]="selectedAction === 'cancel'"
                [class.pca-option--cancel-selected]="selectedAction === 'cancel'" (click)="selectAction('cancel')">
                <mat-icon>cancel_outline</mat-icon>
                <span>Cancel Order</span>
            </button>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pca-actions-bar">
        <button mat-stroked-button (click)="close()" type="button">Close</button>
        <button mat-flat-button class="mm-bg-primary mm-text-white" [disabled]="!selectedAction" (click)="confirm()"
            type="button">
            Confirm
        </button>
    </mat-dialog-actions>
</div>